import React from 'react'
import img1 from '../media/Blog/7_1.png'
import img2 from '../media/Blog/7_2.png'
import img3 from '../media/Blog/7_3.png'
import img4 from '../media/Blog/7_4.png'
import img5 from '../media/Blog/7_5.png'
import img6 from '../media/Blog/7_6.png'
import img7 from '../media/Blog/7_7.png'
import img8 from '../media/Blog/7_8.png'
import img9 from '../media/Blog/7_9.png'
import img10 from '../media/Blog/7_10.png'
import img11 from '../media/Blog/7_11.png'
import img12 from '../media/Blog/7_12.png'
import img13 from '../media/Blog/7_13.png'
import "./blog5.css"
import { Helmet } from 'react-helmet'


export const Blog7 = () => {
    return (
        <>
            <Helmet>
                <meta charset="UTF-8" />
                {/* <meta name="viewport" content="width=device-width, initial-scale=1"></meta> */}
                <title>VS-CODE for Web Development</title>
                <meta name="description" content="Visual Studio Code is a source-code editor made by Microsoft and in this post you will know how to setup VS-Code for Web Development..." />
                <meta name="keywords" content="vscode, webdev, mixrosodt, setup, installation, extension for vscode, extensions, about, about karan, contact-me, karan-dhingra, kd, karan, karandhingra, call, phone, message, chandigarh university, cu, student, android, webdevelopment, development, roadmap, strategy, linkedin, github, karan-dhingra.github.io, lct" />
                <meta name="author" content="Karan Dhingra" />
            </Helmet>
            <div className="container-blogs">
                <h1 className="title-top">VS-CODE for Web Development</h1>
                <div className="body">
                    <p>So, guys in this article I will explain from downloading to set up don’t skip any step.</p>
                    <p>Visual Studio Code is a source-code editor made by Microsoft for Windows, Linux, and macOS. Features include support for debugging, syntax highlighting, intelligent code completion, snippets, code refactoring, and embedded Git. This is Free to use.
                    </p>
                    <br />
                    <h2>Step 1- DOWNLOAD VS-CODE</h2>
                    <ol>
                        <li>
                            <p className="li-para">After making and setting up account choose course which you want to do. suppose you want to do this specialization.</p>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">Click the Operating System you having [Linux/ Windows/ Mac OS]</p>
                            <div className="li-image">
                                <img src={img1} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">When you will click downloading will automatically start.</p>
                        </li>
                        <br />
                    </ol>
                    <br />
                    <h2>Step 2- OPEN VS-CODE</h2>
                    <ol>
                        <li>
                            <p className="li-para"> You will find UI like this [Your theme may be Different]</p>
                            <div className="li-image">
                                <img src={img2} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">Click on File Explorer top left and then click on Open Folder [ File Explorer &gt; Open Folder]</p>
                            <div className="li-image">
                                <img src={img3} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para"> Make a Folder and select it. [Open Folder &gt; Select Folder]</p>
                            <div className="li-image">
                                <img src={img4} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                    </ol>
                    <p><b><i>–– So, we have Downloaded VS-CODE and open the folder now it’s time to install some extensions to code fast and beautifully.</i></b></p>
                    <br />
                    <h2>Step 3- DOWNLOAD EXTENSIONS</h2>
                    <br />
                    <p><b>Why do we need to install it? We need to install it to code fast because use this extension will give you some code snippets. So, you don’t need to write the whole code by yourself and your speed will also increase.</b></p>
                    <ol>
                        <li>
                            <p className="li-para">Click on the Extension button Left Bottom.</p>
                            <div className="li-image">
                                <img src={img5} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para"> Search for Html and you will find this extension at top, open it and install it. [This Extension is for code Snippets]</p>
                            <div className="li-image">
                                <img src={img6} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">Search for Live Server and you will find this at the top, open it and install it. [This Extension is to load your HTML page to browser]</p>
                            <div className="li-image">
                                <img src={img7} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                    </ol>
                    <br />
                    <h2>Step 4- CREATE AND RUN</h2>
                    <ol>
                        <li>
                            <p className="li-para">You will see there are two buttons here [1] is for creating a file and [2] is for creating a folder.</p>
                            <div className="li-image">
                                <img src={img8} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">Click on the second button to create a folder and name it as you want.</p>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">After making the folder click on the first button to create our HTML file. [Make sure you have written proper extension like in our case for HTML file .html and for CSS file .css and for JavaScript file .js ]</p>
                            <div className="li-image">
                                <img src={img9} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">Press ! [Exclamatory Mark] you will find to choose to click the first one and press enter for our Starter Code.</p>
                            <div className="li-image">
                                <img src={img10} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">Write your code you can edit the Title and Body.  After writing the code you will need to test it.</p>
                            <div className="li-image">
                                <img src={img11} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">So, press CTRL+S to save it. Right-click on your file and press open with a live server. [This option will visible if you have installed Live Server extension as explained above]</p>
                            <div className="li-image">
                                <img src={img12} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">You will find the browser is open and your project is visible. **You need to save every time your file you don’t need to refresh browser**</p>
                            <div className="li-image">
                                <img src={img13} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                    </ol>
                    <p className="ending-page">So, that’s how you can set up and download your VS-CODE for WEB-DEVELOPMENT. </p>
                    <br />
                    <p className="ending-page">If you face any issue, you can ask me through comment section or DM me on LinkedIn and if this video helped you like it and share it to your friends. and follow us for our blogs. </p>
                </div>
            </div>
        </>
    )
}

export default Blog7